<template>
<v-container fluid class="py-2 d-flex justify-center Homeoverview" v-if="newsEventsItem.length !== 0">
  <v-container class="px-0 ma-0">
    <v-slide-group selected-class="bg-success" show-arrows>
      <v-slide-group-item v-for="(newsEvent, index) in newsEventsItem" :key="index">
        <v-card v-if="newsEvent.NameUrl && newsEvent.Title" color="backgorund1" class="ma-2">
          <NuxtLink class="text-decoration-none" v-if="['News', 'Event'].includes(newsEvent.Type)" :to="{
            path: $methods.pageUrlByPageType(newsEvent.Type === 'News' ? 'DN' : 'DE') + '/' + newsEvent.NameUrl
          }">
            <v-card value="outlined" class="h-100 d-flex flex-column" elevation="0" width="378">
              <v-img class="flex-grow-0" cover height="189px"
                :src="newsEvent.NiveaImage ? newsEvent.NiveaImage : newsEvent.HeaderImage" :alt="newsEvent.AltText" />
              <v-card-title v-if="newsEvent.Title">
                {{ newsEvent.Title }}
              </v-card-title>
              <v-card-text class="d-flex flex-column flex-grow-1">
                <!-- Alles vanaf hier naar onderkant -->
                <div class="mt-auto">
                  <p v-if="newsEvent.MainText" class="pb-0 mb-0 text-body-2 overflow-y-hidden gradient-text">
                    <span>
                      {{ $helpers.stripHtml(newsEvent.MainText, 175) }}
                    </span>
                  </p>
                </div>
              </v-card-text>
            </v-card>
          </NuxtLink>
        </v-card>
      </v-slide-group-item>
    </v-slide-group>
  </v-container>
</v-container>
</template>
<script setup>
const dataAll = useDataAll();
let page = ref(1);
const { $methods } = useNuxtApp()
const perPage = 4;
const news = useNewsOverviewStore();
const events = useEventOverviewStore();

const { PUBLIC_DATA_URL } = useRuntimeConfig().public
const isDev = process.env.NODE_ENV !== 'production'

// merge a Type in the events en news items
const newsEventsItem = [
  ...news.NewsItems.map(item => ({ ...item, Type: 'News', HeaderImage: isDev ? item.HeaderImage.replaceAll("/PUBLIC", PUBLIC_DATA_URL) : item.HeaderImage })),
  ...events.EventItems.map(item => ({ ...item, Type: 'Event', HeaderImage: isDev ? item.HeaderImage.replaceAll("/PUBLIC", PUBLIC_DATA_URL) : item.HeaderImage }))
];



const Width = computed(() => {
  switch (useNuxtApp().$vuetify.display.mobile._object.name) {
    case "xs":
      return 80;
    case "sm":
      return 80;
    case "md":
      return 95;
    case "lg":
      return 100;
    case "xl":
      return 100;
    case "xxl":
      return 100;
    default:
      return 100;
  }
});

const Textnews = computed(() => {
  switch (useNuxtApp().$vuetify.display.mobile._object.name) {
    case "xs":
      return 80;
    case "sm":
      return 80;
    case "md":
      return 95;
    case "lg":
      return 100;
    case "xl":
      return 100;
    case "xxl":
      return 100;
    default:
      return 100;
  }
});


</script>
